import { render } from "./RengongYlqRwshuiyinView.vue?vue&type=template&id=f80e636a"
import script from "./RengongYlqRwshuiyinView.vue?vue&type=script&lang=js"
export * from "./RengongYlqRwshuiyinView.vue?vue&type=script&lang=js"

import exportComponent from "F:\\allNewWeb\\ant-vue\\antd-demo2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__